/**
 * @desc Utility functions to interact with DOM.
 */
import { messageBus } from 'core/modules/message-bus';
import { DOM_EVENTS } from 'constants/message-bus-events';

/**
 * @desc Add CSS classes to a DOM element.
 * @param {*} domElem - A DOM element
 * @param  {...any} classNames - class name
 * @example
 * import { addClass } from 'utils/dom';
 */
export const addClass = ( domElem, ...classNames ) => {
    if( domElem ) {
        domElem.classList.add( ...classNames );
    }
};

/**
 * @desc Remove CSS classes from a DOM element.
 * @param {*} domElem - A DOM element
 * @param  {...any} classNames - class name
 * @example
 * import { removeClass } from 'utils/dom';
 */
export const removeClass = ( domElem, ...classNames ) => {
    if( domElem ) {
        domElem.classList.remove( ...classNames );
    }
};

/**
 * @desc Lock scroll of the `body` DOM element.
 * @example
 * import { lockBodyScroll } from 'utils/dom';
 */
export const lockBodyScroll = ( enable = true ) => {
    messageBus.trigger( DOM_EVENTS.BODY_LOCK_SCROLL, { enable } );
};

/**
 * @desc Check if a `DOM` element is overflowing (with ellipsis perhaps).
 * @example
 * import { isOverflowing } from 'utils/dom';
 */
export const isOverflowing = ( domElem ) => {
    if( ! domElem ) {
        return false;
    }

    // if `scroll-width` is greater than `offset-width`, element is overflowing
    return domElem.offsetWidth < domElem.scrollWidth;
};
